import React from "react"
import { VictoryLine, VictoryChart, VictoryAxis, VictoryLegend, VictoryLabel } from 'victory'
import tinycolor from 'tinycolor2'

import statStyles from '../components/era_adj_elo.module.scss'

const EloChart = ({data}) => {

    const chart_colors = [
        '#121280',
        '#680fd9',
        '#d13bb9',
        '#e05376',
        '#ff8f75'
    ]
    var legendData = []
    var lineData = []
    var lineStyles =[]

    for (var datum in data) {
        legendData.push(
            {
                'name' : data[parseInt(datum)]['qb_name'],
                'strokeColor' : chart_colors[parseInt(datum)],
                'strokeOpac' : 1,
            }
        )
        lineStyles.push(
            {
                data: {
                    stroke : chart_colors[parseInt(datum)],
                    opacity: .75,
                },
                labels: {
                    fill: chart_colors[parseInt(datum)],
                    fontSize: 12,
                },
            }
        )
        lineData.push(
            []
        )
        for (var game in data[parseInt(datum)]['games']) {
            var dataPoint = {
                'qb_name' : data[parseInt(datum)]['qb_name'],
                'qb_color' : chart_colors[parseInt(datum)],
                'game_number' : data[parseInt(datum)]['games'][parseInt(game)]['game_number'],
                'era_adj_elo' : data[parseInt(datum)]['games'][parseInt(game)]['era_adjusted_elo'],
            }
            if (parseInt(game) === data[parseInt(datum)]['games'].length-1) {
                dataPoint['label'] = dataPoint['qb_name']
            }
            lineData[parseInt(datum)].push(
                dataPoint
            )
        }
    } 

    const setPctColor = (pct) => {

        const baseColor = '#ffffff'
        const highlightColor = '#b5fff7'

        return(
            tinycolor.mix(baseColor, highlightColor, parseFloat(pct)*50)
        )

    }

    return (

        <div className={statStyles.chart_wrapper}>
            <h2 className={statStyles.section_header}>
                Summarized Stats
            </h2>
            <div className={statStyles.career_container}>
                <table className={statStyles.career_table}>
                    <thead className={statStyles.career_table_header}>
                        <th>
                            Player
                        </th>
                        <th>
                            Games
                        </th>
                        <th>
                            Era Adj. Career Elo
                        </th>
                        <th>
                            Elo / Game
                        </th>
                        <th>
                            WP%
                        </th>
                        <th>
                            % as The Best QB
                        </th>
                        <th>
                            % as a Top 3 QB
                        </th>
                        <th>
                            % as a Top 5 QB
                        </th>
                    </thead>
                    <tbody>
                        {data.map((row) => {
                            return (
                                <tr className={statStyles.career_table_row}>
                                    <td>
                                        {row['qb_name']}
                                    </td>
                                    <td>
                                        {row['total_starts']}
                                    </td>
                                    <td>
                                        {Math.round(row['cumulative_era_adjusted_elo_value'])}
                                    </td>
                                    <td>
                                        {
                                            Math.round(10*
                                                row['cumulative_era_adjusted_elo_value'] /
                                                row['total_starts']
                                            )/10
                                        }
                                    </td>
                                    <td>
                                        {Math.round(100*row['winning_percentage'])}%
                                    </td>
                                    <td style={{backgroundColor : setPctColor(row['pct_of_starts_as_best_qb'])}}>
                                        {Math.round(100*row['pct_of_starts_as_best_qb'])}%
                                    </td>
                                    <td style={{backgroundColor : setPctColor(row['pct_of_starts_as_top3_qb'])}}>
                                        {Math.round(100*row['pct_of_starts_as_top3_qb'])}%
                                    </td>
                                    <td style={{backgroundColor : setPctColor(row['pct_of_starts_as_top5_qb'])}}>
                                        {Math.round(100*row['pct_of_starts_as_top5_qb'])}%
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className={statStyles.spacer_div}></div>
            <h2 className={statStyles.section_header}>
                Era Adjusted Career Elo
            </h2>
            <div className={statStyles.career_container}>
                <VictoryChart
                    domainPadding={{
                        y:[15,15],
                        x:[0,15]
                    }}
                    width={550}
                    height={300}
                >
                    <VictoryLegend
                        orientation='horizontal'
                        x={50}
                        y={10}
                        symbolSpacer={6}
                        data={legendData}
                        style={{
                            data: {
                                fill : 'none',
                                stroke : ({datum}) => datum.strokeColor,
                                opacity : ({datum}) => datum.strokeOpac,
                                strokeDasharray : ({datum}) => datum.strokeDash,
                            },
                            labels: {
                                fill : ({datum}) => datum.strokeColor,
                                opacity : ({datum}) => datum.strokeOpac,
                                fontSize: 10,
                            }
                        }}
                    />
                    <VictoryAxis
                        label='Game Number'
                        style={{
                            axisLabel: {
                                fontSize: '12px',
                                padding: '30',
                            },
                            tickLabels: {
                                fontSize: '10px',
                                color: '#808080',
                            },
                        }}
                        orientation='bottom'
                        offsetY={50}
                    />
                    <VictoryAxis
                        dependentAxis
                        style={{
                            tickLabels: {
                                fontSize: '10px',
                                color: '#808080',
                            }
                    }}
                    />
                    {data.map((row) => {
                        return(
                            <VictoryLine
                                style={lineStyles[data.indexOf(row)]}
                                data={lineData[data.indexOf(row)]}
                                x='game_number'
                                y='era_adj_elo'
                                labelComponent={
                                    <VictoryLabel
                                        textAnchor='start'
                                        verticalAnchor='middle'
                                        dy={-3}
                                        renderInPortal={true}
                                        backgroundStyle = {{
                                            fill: 'white',
                                            opacity: .75,
                                        }}
                                        backgroundPadding={{
                                            left:1,
                                            bottom:3,
                                        }}
                                    />
                                }
                            />
                        )
                    })}
                </VictoryChart>
            </div>
        </div>

    )
}

export default EloChart